import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceWhitespaceWithUnderscore',
})
export class ReplaceWhitespaceWithUnderscorePipe implements PipeTransform {
  transform(value: string | undefined): string | undefined {
    if (!value) {
      return undefined;
    }
    return value.replaceAll(' ', '_');
  }
}
